import React, { forwardRef } from 'react';
import dayjs from 'utils/dayjs';
import { Input, InputGroup, InputRightElement, Icon } from '@spothero/ui';
import { Calendar as IconCalendar } from '@spothero/icons';
export const getDatesInput = (dates) => {
    const formattedDates = dates.map(val => val.replace(/-/g, '/'));
    formattedDates.sort((a, b) => {
        if (dayjs(a).isAfter(b))
            return 1;
        if (dayjs(b).isAfter(a))
            return -1;
        return 0;
    });
    return formattedDates.reduce((acc, val) => `${acc}${acc ? ', ' : ''}${dayjs(val).format('MM/DD')}`, '');
};
const MultiSelectDatePickerInput = forwardRef(({ openDatePicker, highlightedDates }, ref) => {
    const finalInputValue = (highlightedDates &&
        (highlightedDates.length <= 4
            ? `${getDatesInput(highlightedDates)}`
            : `${highlightedDates.length} Days Selected`)) ||
        '';
    return (<InputGroup display="block" width={{ base: 'full', tablet: '250px', desktop: '250px' }}>
                <Input aria-label="multi-select-datepicker-input" variant="outline" placeholder="Select Days" onClick={openDatePicker} isReadOnly value={finalInputValue} cursor="default" fontFamily='"Open Sans", sans-serif' id="multi-select-datepicker-input" data-testid="MultiSelectDatePicker-input" ref={ref}/>
                <InputRightElement pointerEvents="none">
                    <Icon as={IconCalendar} color="primary.default" data-testid="MultiSelectDatePicker-input-calendar-icon"/>
                </InputRightElement>
            </InputGroup>);
});
export default MultiSelectDatePickerInput;
